import { useState } from "react";
import Header from "../Common/Header";
import Footer from "../Common/Footer";


/* Styles */
const overlayStyle = {
  position: "fixed",
  top: 0,
  left: 0,
  right: 0,
  bottom: 0,
  background: "rgba(0,0,0,0.5)",
  display: "flex",
  alignItems: "center",
  justifyContent: "center",
  zIndex: 1000,
};

const dialogStyle = {
  background: "#fff",
  padding: "20px",
  borderRadius: "8px",
  width: "60vw",
};

const optionStyle = {
  padding: "10px",
  borderBottom: "1px solid #ddd",
  cursor: "pointer",
};
const closeBtn = {   
    float: "right",
    marginTop: -18,
    fontSize: 18,
    marginRight: -8
}
function PostPropertyNew() { 
  

  const [step, setStep] = useState(1);
  const nextStep = () => step < 5 && setStep(step + 1);
  const prevStep = () => step > 1 && setStep(step - 1);

  const STEPS = [
    "Location",
    "Category",
    "Property Info",
    "Basic Details",
    "Map Location",
  ];



  return (

    <>
    <Header />
    <section className="pt-140 pb-75 bg-seashell postproperty">
      <div className="container">
        <div className="row">
          <div className="col-md-3 col-sm-3 d-desk">
            <div className="card">
            <h4 className="title tle">Post your property</h4>
            <div className="stepper">
              {STEPS.map((label, index) => {
                const stepNumber = index + 1;
                return (
                  <div key={label} className="step-item">
                    <div className={`step-dot ${step >= stepNumber ? "active" : ""}`}>{stepNumber}</div>
                    <span
                      className={`step-label ${step === stepNumber ? "current" : ""}`}>
                      {label}
                    </span>
                  </div>
                );
              })}
            </div>

            <p className="step-text">Need help?</p>
            <small>Now you can directly post property via</small>
            <span className="Whatsapp"><i className="ri-whatsapp-line" /> Whatsapp</span>
            </div>
          </div>
          <div className="col-md-9 col-sm-9 wd100">
          <div className="stepper d-mobilee">
              {STEPS.map((label, index) => {
                const stepNumber = index + 1;
                return (
                  <div key={label} className="step-item">
                    <div className={`step-dot ${step >= stepNumber ? "active" : ""}`}>{stepNumber}</div>
                    <span
                      className={`step-label ${step === stepNumber ? "current" : ""}`}>
                      {label}
                    </span>
                  </div>
                );
              })}
            </div>
            <div className="content card">
              {step === 1 && <Step1 />}
              {step === 2 && <Step2 />}
              {step === 3 && <Step3 />}
              {step === 4 && <Step4 />}
              {step === 5 && <Step5 />}
            </div>

            <div className="footers">
              <button
                className="btn secondary"
                disabled={step === 1}
                onClick={prevStep}
              >
                Previous
              </button>

              {step < 5 ? (
                <button className="btn primary" onClick={nextStep}>
                  {step === 1 ? "Next Step" : "Next"}
                </button>
              ) : (
                <button className="btn primary">Submit</button>
              )}
            </div>
          </div>
        </div>

      </div>
    </section>
    <Footer />
    </>
  );
}

function Step1() {
  
  const [open, setOpen] = useState(false);
  const [value, setValue] = useState("");

  const options = ["Faridabad", "Noida", "Jaipur", "Delhi", "Ghaziabad"];

 const handleSelectClick = (e) => {
    e.preventDefault(); // prevent default dropdown
    setOpen(true);
  };

  const handleOptionSelect = (option) => {
    setValue(option);
    setOpen(false);
  };


  return (
    <>
      <h4>Location Details</h4>


        <div class="form-group">
            <select
                    value={value}
                    onMouseDown={handleSelectClick}
                    style={{ padding: "10px",}}
                  >
                    <option value="">
                      {value ? value : "Select City"}
                    </option>
                  </select>
            </div>
        {/* <div class="form-group">
            <label className="label">City<span className="red">*</span></label>
            <select name="category" id="category" >
                <option value="Faridabad">Faridabad</option>
                <option value="Noida">Noida</option>
                <option value="Delhi">Delhi</option>
                <option value="Jaipur">Jaipur</option>
            </select>
        </div> */}

     
        <div class="form-group">
            <label className="label">Locality<span className="red">*</span></label>
            <select name="category" id="category">
                <option value="Sector 15">Sector 15</option>
                <option value="Sector 16">Sector 16</option>
                <option value="Sector 17">Sector 17</option>
                <option value="Sector 18">Sector 18</option>
                <option value="Sector 19">Sector 19</option>
                <option value="Sector 20">Sector 20</option>
                <option value="Sector 22">Sector 22</option>
            </select>
        </div>

        <div class="form-group">
            <label className="label">Street/Building/Area<span className="red">*</span></label>
            <select name="category" id="category">
                <option value="Sector 15">Godrej Nest Phase 1, Sector 150, Noida</option>
                <option value="Sector 15">Godrej Nest Phase 1, Sector 150, Noida</option>
            </select>
        </div> 


         {/* Dialog */}
      {open && (
        <div style={overlayStyle}>
          <div style={dialogStyle} className="dialoggs">
                <div style={closeBtn}>
                <i className="ri-close-line" onClick={() => setOpen(false)}  />
            </div>
               <div class="form-group">
                  <input className="input" placeholder="Search City" />      
                </div>

            <h5>Select City</h5>
            <div className="dialogcontent">
            {options.map((option, index) => (
              <div
                key={index}
                style={optionStyle}
                onClick={() => handleOptionSelect(option)}
              >
                {option}
              </div>
            ))}
          </div>
        
          </div>
        </div>
      )}
       
    
    </>
  );
}

function Step2() {
  return (
    <>
      <h4>Category & Property Type</h4>

      <label className="label">Category<span className="red">*</span></label>
      <ButtonGroup options={["Residential", "Commercial"]} />

      <label className="label">Looking To<span className="red">*</span></label>
      <ButtonGroup options={["Sale", "Rent",  "PG/Co-Living"]} />

      <label className="label">Property Type<span className="red">*</span></label>
      <ButtonGroup
        options={["Plot", "Warehouse", "Showroom", "Retail Shop", "Office", "Apartment", "Farm House", "Studio", "Penthouse", "Independent House", "Duplex", "Villa"]}
      />
    </>
  );
}

function Step3() {
  const [open, setOpen] = useState(false);
  const [value, setValue] = useState("");

  const options = ["df", "Noida", "Jaipur", "Delhi", "Ghaziabad"];

 const handleSelectClick = (e) => {
    e.preventDefault(); // prevent default dropdown
    setOpen(true);
  };

  const handleOptionSelect = (option) => {
    setValue(option);
    setOpen(false);
  };

const [quantity, setQuantity] = useState(1);

  const increaseQty = () => {
    setQuantity(quantity + 1);
  };

  const decreaseQty = () => {
    if (quantity) {
      setQuantity(quantity - 1);
    }
  };

  return (
    <>
      <h4>Property Information</h4>
      <div className="form-group">
        <label className="label">BHK Type<span className="red">*</span></label>
        <ButtonGroup options={["1 BHK", "2 BHK", "2.5 BHK", "3 BHK", "3.5 BHK", "4 BHK", "4.5 BHK", "PLOT 1", "PLOT 2", "PLOT 3", "4 BHK PENTHOUSE"]} />
      </div>
      <div className="form-group">
        <label className="label">Area Unit<span className="red">*</span></label>
        <ButtonGroup options={["acre", "sq. yd.", "sq. ft.", "sq. mt."]} />
      </div>


      <div className="form-group">
        <label className="label">Built-up Area (acre)<span className="red">*</span></label>
        <input className="input" placeholder="eg 1250" />
      </div>

      <div className="form-group">
         <label className="label">Price(Rs)<span className="red">*</span></label>
          <input className="input" placeholder="eg10" />
      </div>

       <div className="form-group">
        <label className="label">Furnishing<span className="red">*</span></label>
        <ButtonGroup options={["Unfurnished", "Semi Furnished", "Fully Furnished"]} />
      </div>


 <div class="form-group">
     <label className="label">Society Amenities<span className="red">*</span></label>
            <select
                    value={value}
                    onMouseDown={handleSelectClick}
                    style={{ padding: "10px",}}
                  >
                    <option value="">
                      {value ? value : "Society Amenities"}
                    </option>
                  </select>
            </div>

    {/* <div class="form-group">
            <label className="label">Society Amenities<span className="red">*</span></label>
            <select name="category" id="category">
                <option value="CCTV">CCTV</option>
                <option value="Community Hall">Community Hall</option>
                <option value="Club House">Club House</option>
                <option value="Kids Area">Kids Area</option>
            </select>
        </div> */}

        
    <div class="form-group">
            <label className="label">Property Furnishing<span className="red">*</span></label>
            <select name="category" id="category">
                <option value="Bed">Bed</option>
                <option value="TV">TV</option>
                <option value="Wardrobe">Wardrobe</option>
                <option value="Light">Light</option>
            </select>
        </div>

        <div className="row">
        <div className="col-md-6">
            <div className="form-group">
                <label className="label">Floor No.<span className="red">*</span></label>
                <input  className="input" placeholder="eg 1" />
            </div>

        </div>
        <div className="col-md-6">
            <div className="form-group">
                <label className="label">Total Floors<span className="red">*</span></label>
                <input className="input" placeholder="eg 10" />
            </div>

        </div>
        </div>

    <div class="form-group">
            <label className="label">Property Age<span className="red">*</span></label>
            <select name="category" id="category">
                <option value="Under Construction">Under Construction</option>
                <option value="1-5 Years">1-5 Years</option>
                <option value="5-10 Years">5-10 Years</option>
                <option value="10-15 years">10-15 years</option>
            </select>
        </div>

<div class="form-group">
      <label className="label">Location Hub<span className="red">*</span></label>
      <ButtonGroup
        options={[
          "North",
          "South",
          "East",
          "West",
          "North-East",
          "North-West",
          "South-East",
          "South-West",
        ]}
      />
      
      </div>
   

         {/* Dialog */}
      {open && (
        <div style={overlayStyle}>
          <div style={dialogStyle} className="dialoggs">
                <div style={closeBtn}>
                    <i className="ri-close-line" onClick={() => setOpen(false)}  />
                </div>
              
            <h5>Society Amenities</h5>
            <div className="dialogcontent">
                <ul className="amenities">
                    <li>
                        <i className="ri-sofa-line" />
                        <span>Dining Table</span>

                        <div className="qty">
                          <div style={{ display: "flex", alignItems: "center", gap: "10px" }} className='itm-Quantity-wrap'>
                            <button onClick={decreaseQty}>-</button>
                            <span id="itm-Quantity">{quantity}</span>
                            <button onClick={increaseQty}>+</button>
                        </div> 
                        </div>
                    </li>
                    <li>
                        <i className="ri-sofa-line" />
                        <span>Washing Machine</span>
                        <div className="qty">
                          <div style={{ display: "flex", alignItems: "center", gap: "10px" }} className='itm-Quantity-wrap'>
                            <button onClick={decreaseQty}>-</button>
                            <span id="itm-Quantity">{quantity}</span>
                            <button onClick={increaseQty}>+</button>
                        </div> 
                        </div>
                    </li>
                    <li>
                        <i className="ri-sofa-line" />
                        <span>Sofa</span>
                        <div className="qty">
                          <div style={{ display: "flex", alignItems: "center", gap: "10px" }} className='itm-Quantity-wrap'>
                            <button onClick={decreaseQty}>-</button>
                            <span id="itm-Quantity">{quantity}</span>
                            <button onClick={increaseQty}>+</button>
                        </div> 
                        </div>
                    </li>
                    <li>
                        <i className="ri-sofa-line" />
                        <span>Cupboard</span>
                        <div className="qty">
                          <div style={{ display: "flex", alignItems: "center", gap: "10px" }} className='itm-Quantity-wrap'>
                            <button onClick={decreaseQty}>-</button>
                            <span id="itm-Quantity">{quantity}</span>
                            <button onClick={increaseQty}>+</button>
                        </div> 
                        </div>
                    </li>
                    <li>
                        <i className="ri-sofa-line" />
                        <span>Microwave</span>
                        <div className="qty">
                          <div style={{ display: "flex", alignItems: "center", gap: "10px" }} className='itm-Quantity-wrap'>
                            <button onClick={decreaseQty}>-</button>
                            <span id="itm-Quantity">{quantity}</span>
                            <button onClick={increaseQty}>+</button>
                        </div> 
                        </div>
                    </li>
                    <li>
                        <i className="ri-sofa-line" />
                        <span>Stove</span>
                        <div className="qty">
                          <div style={{ display: "flex", alignItems: "center", gap: "10px" }} className='itm-Quantity-wrap'>
                            <button onClick={decreaseQty}>-</button>
                            <span id="itm-Quantity">{quantity}</span>
                            <button onClick={increaseQty}>+</button>
                        </div> 
                        </div>
                    </li>
                    <li>
                        <i className="ri-sofa-line" />
                        <span>Fridge</span>
                        <div className="qty">
                          <div style={{ display: "flex", alignItems: "center", gap: "10px" }} className='itm-Quantity-wrap'>
                            <button onClick={decreaseQty}>-</button>
                            <span id="itm-Quantity">{quantity}</span>
                            <button onClick={increaseQty}>+</button>
                        </div> 
                        </div>
                    </li>
                    <li>
                        <i className="ri-sofa-line" />
                        <span>Fan</span>
                        <div className="qty">
                          <div style={{ display: "flex", alignItems: "center", gap: "10px" }} className='itm-Quantity-wrap'>
                            <button onClick={decreaseQty}>-</button>
                            <span id="itm-Quantity">{quantity}</span>
                            <button onClick={increaseQty}>+</button>
                        </div> 
                        </div>
                    </li>
                    <li>
                        <i className="ri-sofa-line" />
                        <span>Light</span>
                        <div className="qty">
                          <div style={{ display: "flex", alignItems: "center", gap: "10px" }} className='itm-Quantity-wrap'>
                            <button onClick={decreaseQty}>-</button>
                            <span id="itm-Quantity">{quantity}</span>
                            <button onClick={increaseQty}>+</button>
                        </div> 
                        </div>
                    </li>
                    <li>
                        <i className="ri-sofa-line" />
                        <span>Wardrove</span>
                        <div className="qty">
                          <div style={{ display: "flex", alignItems: "center", gap: "10px" }} className='itm-Quantity-wrap'>
                            <button onClick={decreaseQty}>-</button>
                            <span id="itm-Quantity">{quantity}</span>
                            <button onClick={increaseQty}>+</button>
                        </div> 
                        </div>
                    </li>
                    <li>
                        <i className="ri-sofa-line" />
                        <span>TV</span>
                        <div className="qty">
                          <div style={{ display: "flex", alignItems: "center", gap: "10px" }} className='itm-Quantity-wrap'>
                            <button onClick={decreaseQty}>-</button>
                            <span id="itm-Quantity">{quantity}</span>
                            <button onClick={increaseQty}>+</button>
                        </div> 
                        </div>
                    </li>
                    <li>
                        <i className="ri-sofa-line" />
                        <span>Bed</span>
                        <div className="qty">
                          <div style={{ display: "flex", alignItems: "center", gap: "10px" }} className='itm-Quantity-wrap'>
                            <button onClick={decreaseQty}>-</button>
                            <span id="itm-Quantity">{quantity}</span>
                            <button onClick={increaseQty}>+</button>
                        </div> 
                        </div>
                    </li>
                    <li>
                        <i className="ri-sofa-line" />
                        <span>Geyser</span>
                        <div className="qty">
                          <div style={{ display: "flex", alignItems: "center", gap: "10px" }} className='itm-Quantity-wrap'>
                            <button onClick={decreaseQty}>-</button>
                            <span id="itm-Quantity">{quantity}</span>
                            <button onClick={increaseQty}>+</button>
                        </div> 
                        </div>
                    </li>
                </ul>

            </div>
        
          </div>
        </div>
      )}
       
    
    </>
  );
}


function Step4() {
  return (
    <>
      <h4>Basic Details</h4>
      <div class="form-group">
      <label  className="label">Description<span className="red">*</span></label>
      <textarea className="textarea" placeholder="Describe your property features, facilities, and amenities etc." />
      </div>
    </>
  );
}

function Step5() {
  return (
    <>
      <h4>Location Information</h4>
     
      <div class="form-group">
      <input className="input" placeholder="Search location" />
      
       </div>
      <div className="map-placeholder"><iframe src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d7007.472031094104!2d77.30975063847217!3d28.577688774550033!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x390ce45b7e24b733%3A0xb8dd905f45fbfcd5!2sSector%2016%2C%20Noida%2C%20Uttar%20Pradesh%20201301!5e0!3m2!1sen!2sin!4v1767945228754!5m2!1sen!2sin" width="100%" height="100%"  allowfullscreen="" loading="lazy" referrerpolicy="no-referrer-when-downgrade"></iframe></div>
    </>
  );
}


function ButtonGroup({ options }) {
  const [active, setActive] = useState(options[0]);

  return (
    <div className="btn-group">
      {options.map((opt) => (
        <button
          key={opt}
          className={`option ${active === opt ? "selected" : ""}`}
          onClick={() => setActive(opt)}
        >
          {opt}
        </button>
      ))}
    </div>
  );
}


 
export default PostPropertyNew;
